import { resetLayoutsToEmpty } from "store/actions/layout";
import { resetPollStateAction } from "store/actions/polling";
import { resetAnomalyAction } from "store/actions/smartInsights";
import { resetSystemsAction } from "store/actions/systemsAndLiveAlarms";
import { resetUserAction } from "store/actions/userProfile";

export default function useStoreHandler(dispatch) {
  const resetStore = () => {
    dispatch(resetLayoutsToEmpty());
    dispatch(resetSystemsAction());
    dispatch(resetPollStateAction());
    dispatch(resetAnomalyAction());
  };

  const resetUserStore = () => dispatch(resetUserAction());

  return { resetStore, resetUserStore };
}
